import React from 'react';
import PropTypes from 'prop-types';
import ReactCollapse from 'react-collapse';
import { classes } from './Collapse.st.css';
/** `<Collapse/>` component is used for hideable content.
 *
 * Easily create accordions or within `<Card/>` to collapse its `<Card.Content/>`.
 */

var Collapse = function Collapse(_ref) {
  var children = _ref.children,
      open = _ref.open,
      dataHook = _ref.dataHook;
  return /*#__PURE__*/React.createElement(ReactCollapse, {
    "data-hook": dataHook,
    theme: {
      collapse: classes.collapse
    },
    isOpened: open,
    children: children
  });
};

Collapse.displayName = 'Collapse';
Collapse.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  dataHook: PropTypes.string
};
Collapse.defaultProps = {
  open: true
};
export default Collapse;